const S1 =
  'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.';
const S2 =
  'Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.';
const S3 = 'Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.';
const S4 =
  'Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.';

export const FAQ_ITEMS = [
  {
    question: 'What can the AI Assistant help me with?',
    answer: [S1, S2, S3, S4].join(' '),
  },
  {
    question: 'Which AI Specialist should I choose for my task?',
    answer: [S1, S2, S3].join(' '),
  },
  {
    question: 'Why does the Assistant ask for a Deal ID?',
    answer: [S1, S2].join(' '),
  },
  {
    question: 'Can I use the Assistant without linking a specific Deal?',
    answer: [S1, S2, S3, S4].join(' '),
  },
  {
    question: "Why can't I edit a newly created audience right away?",
    answer: [S2, S3, S4].join(' '),
  },
  {
    question: 'Can I resize or move the Assistant window if it blocks my screen?',
    answer: [S3, S4].join(' '),
  },
];
